
import { i18nText } from '@/locales';
import Vue from 'vue';
import Component from 'vue-class-component';
import { ITableColumn } from '@/entity/table/table.types';

@Component
export class SaleTargetsColumns extends Vue {

    get columnsSaleTarget(): ITableColumn[] {
        return [
            {
                title: i18nText("Студии"),
                dataIndex: 'key0',
                key: '0',
            },
            {
                title: i18nText("Заявок"),
                dataIndex: 'key1',
                key: '1',
            },
            {
                title: i18nText("Записей"),
                dataIndex: 'key2',
                key: '2',
            },
            {
                title: i18nText("Пришло"),
                dataIndex: 'key3',
                key: '3',
            },
            {
                title: i18nText("Продажи"),
                dataIndex: 'key4',
                key: '4',
            },
            {
                title: i18nText("Абон."),
                dataIndex: 'key0',
                key: '5',
            },
            {
                title: i18nText("Ср. чек"),
                dataIndex: 'key1',
                key: '6',
            },
            {
                title: i18nText("Выручка"),
                dataIndex: 'key2',
                key: '7',
            },
            {
                title: i18nText("Расходы"),
                dataIndex: 'key3',
                key: '8',
            },
            {
                title: i18nText("Прибыль"),
                dataIndex: 'key4',
                key: '9',
            },
            {
                title: i18nText("План"),
                dataIndex: 'key4',
                key: '10',
            },
            {
                title: '',
                dataIndex: '',
                key: '11',
                scopedSlots: {
                    customRender: 'edit'
                }
            },
        ]
    }

    get columnsByEmployee(): ITableColumn[] {
        return [
            {
                title: i18nText("Сотрудник"),
                dataIndex: 'key0',
                key: '0',
            },
            {
                title: i18nText("Выручка"),
                dataIndex: 'key1',
                key: '1',
            },
            {
                title: i18nText("Сумма"),
                dataIndex: 'key2',
                key: '2',
            },
            {
                title: i18nText("Кол-во"),
                dataIndex: 'key3',
                key: '3',
            },
            {
                title: i18nText("Сумма"),
                dataIndex: 'key4',
                key: '4',
            },
            {
                title: i18nText("Кол-во"),
                dataIndex: 'key0',
                key: '5',
            },
            {
                title: i18nText("Скидка"),
                dataIndex: 'key1',
                key: '6',
            },
            {
                title: i18nText("Баллы"),
                dataIndex: 'key2',
                key: '7',
            },
            {
                title: i18nText("Абонементы"),
                dataIndex: 'key3',
                key: '8',
            },
            {
                title: i18nText("Сертификаты"),
                dataIndex: 'key4',
                key: '9',
            },
            {
                title: i18nText("Будущие записи"),
                dataIndex: 'key4',
                key: '10',
            },
            {
                title: i18nText("Отработано часов"),
                dataIndex: '',
                key: '11',
                scopedSlots: {
                    customRender: 'check'
                }
            },
            {
                title: i18nText("Стоимость часа работ"),
                dataIndex: '',
                key: '12',
                scopedSlots: {
                    customRender: 'check'
                }
            },
            {
                title: i18nText("% от общей выручки"),
                dataIndex: '',
                key: '13',
            },
            {
                title: '',
                dataIndex: '',
                key: '14',
                scopedSlots: {
                    customRender: 'check'
                }
            },
        ]
    }

    get columnsSaleByService(): ITableColumn[] {
        return [
            {
                title: i18nText("Услуга"),
                dataIndex: 'name',
                key: '0',
            },
            {
                title: i18nText("Кол-во оказанных услуг"),
                dataIndex: 'quantity',
                key: '1',
            },
            {
                title: i18nText("Оплачено скидкой"),
                dataIndex: 'cost_price',
                key: '2',
            },
            {
                title: i18nText("Оплачено со счетов клиентов"),
                dataIndex: 'price',
                key: '3',
            },
            {
                title: i18nText("Оплачено деньгами"),
                dataIndex: 'price',
                key: '4',
            },
            {
                title: i18nText("Стоимость расходников"),
                dataIndex: 'price',
                key: '5',
            },
            {
                title: i18nText("ЗП сотрудников"),
                dataIndex: 'price',
                key: '6',
            },
            {
                title: i18nText("Прибыль"),
                dataIndex: 'price',
                key: '7',
            },
            {
                title: i18nText("% от текущей выручки"),
                dataIndex: 'price',
                key: '8',
            },
        ]
    }

    get columnsSaleByClient(): ITableColumn[] {
        return [
            {
                title: i18nText("Клиент"),
                dataIndex: 'key0',
                key: '0',
            },
            {
                title: i18nText("Выручка"),
                dataIndex: 'key1',
                key: '1',
            },
            {
                title: i18nText("% от общей выручки"),
                dataIndex: 'key2',
                key: '2',
            },
            {
                title: i18nText("Средний чек"),
                dataIndex: 'key3',
                key: '3',
            },
            {
                title: i18nText("Кол-во посещений"),
                dataIndex: 'key4',
                key: '4',
            },
        ]
    }
}
